var oneTimeHtml = `
  <div class="tw-buy__title">
    <p>Buy</p>
    <div class="tw-buy__texts">
      <p>Perfect for trying the product</p>
      <p>Get results in 30 deys, <u>or your money back</u></p>
    </div>
  </div>
  `

var viewDetailsHtml = `
  <div class="tw-subs__wrapper">
        <a href="#">View details <img src="https://cdn.shopify.com/s/files/1/0668/3826/6157/files/arrow-bottom.png?v=1668058149"></a>
  </div>
  `

var viewDetailsElement = function () {
  const el = document.createElement('template')
  el.innerHTML = viewDetailsHtml.trim()
  return el
}

function isOneTimeProduct() {
  oneTimeHtml = document.querySelector('.sls-purchase-options-container > :nth-of-type(1) .sls-selling-plan-group-name').innerHTML || ''
  return oneTimeHtml.includes('One-time purchase')
}

function isSubscriptionProduct() {
  oneTimeHtml = document.querySelector('.sls-purchase-options-container > :nth-of-type(1) .sls-selling-plan-group-name').innerHTML || ''
  return oneTimeHtml.includes('Subscribe')
}

function createWrapperNode(el) {
  const wrapper = document.createElement('div')
  wrapper.classList.add('tw-buy__wrapper')

  return wrapper
}

// This replaces texts in product-detail in regards to price.
// Improves options, gives option of subscription if one-time payment.
// Does not give one-time option in case of subscription.
// Renames one-time purchase to simple "Buy" - not configurable from app setting.
setTimeout(() => {
  const isSubscription = !!document.getElementsByClassName('sealsubs-container')[0]
  const subElement = document.getElementsByClassName('sealsubs-target-element')[0]
  const priceWrapper = document.getElementsByClassName('tw-price__wrapper')[0]

  if (!priceWrapper) {
    console.log('[priceWrapper_FALSE]')
    return
  }

  if (!isSubscription) {
    console.log('[subscriptionContainerExists_FALSE]')

    priceWrapper.style.display = 'block'
    priceWrapper.nextElementSibling.style.display = 'block'
    priceWrapper.classList.add('ie_always_visible')

    return
  }

  subElement.style.display = 'block'
  priceWrapper.style.display = 'none'
  priceWrapper.nextElementSibling.style.display = 'none'

  const firstText = document.querySelector('.sls-purchase-options-container > :nth-of-type(1) .sls-selling-plan-group-name')
  const secondText = document.querySelector('.sls-purchase-options-container > :nth-of-type(2) .sls-selling-plan-group-name')

  if (firstText.innerHTML.includes('One-time purchase')) {
    console.log('[First text]')
    firstText.innerHTML = oneTimeHtml
  } else if (secondText) {
    console.log('[Second text]')

    const wrapper = document.querySelector('.sls-purchase-options-container > :nth-of-type(2) .sls-label-container')
    wrapper.append(viewDetailsElement())
  }
}, 2000)
